import React from 'react';

import ArtistName from 'components/Wizard/steps/ArtistName';
import { StepCreatorParams, WizardStepConfig } from 'components/Wizard/types';
import { TextEmphasis } from '@protonradio/proton-ui';

/**
 * Returns a configuration object for the Artist Name step in the Wizard, used to determine
 * if an artist profile already exists on Proton or not.
 */

export const createArtistNameStep = ({
  artistProfile,
  context
}: StepCreatorParams): WizardStepConfig => {
  const artistName = artistProfile?.name;
  const state = artistName ? 'artistSelected' : 'noArtist';

  const PARAMS_BY_STATE = {
    artistSelected: {
      buttonText: 'View',
      subtitle: (
        <span>
          You are editing the artist profile for <TextEmphasis>{artistName}</TextEmphasis>
          .
        </span>
      )
    },
    noArtist: {
      buttonText: 'Get Started',
      subtitle: "We'll make sure they don't already have a Proton profile."
    }
  };

  const params = PARAMS_BY_STATE[state];

  return {
    overviewRow: {
      title: 'Artist Name',
      subtitle: params.subtitle,
      // NOTE: by default, the button will navigate to the step url
      buttonText: params.buttonText
    },
    id: 'artist-name',
    path: `/artist-profile-editor/${context}/artist-name`,
    isRequired: true,
    isComplete: !!artistName,
    // TODO: Should we wrap ArtistName in WizardStep here (or in ArtistContextWizardRenderer) to reduce prop drilling?
    render: wizardProps => <ArtistName {...wizardProps} artistProfile={artistProfile} />
  };
};
